<template>
  <div class="chemical_pup">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="100px"
      label-position="left"
      required
    >
      <el-form-item label="化学品:" prop="hxpmc">
        <span>{{ form.hxpmc }}</span>
        <i
          v-show="!this.form.unalterable"
          v-preventReClick
          class="el-icon-circle-plus-outline"
          style="cursor: pointer"
          @click="innerVisible = true"
        />
      </el-form-item>
      <el-form-item label="业务类型:" prop="ywlx">
        <el-select
          v-model="form.ywlx"
          :disabled="this.form.unalterable == true"
          placeholder="请选择"
          style="width: 100%"
          @change="changenewClass"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <div style="display: flex; display: flex; justify-content: space-between">
        <el-form-item label="年涉及数量:" prop="nsjsl" style="flex-grow: 2">
          <el-input
            v-model="form.nsjsl"
            placeholder="请输入年涉数量"
          />
        </el-form-item>
        <el-form-item prop="nsjslDwLabel">
          <el-select
            v-model="form.nsjslDwLabel"
            placeholder="请选择"
            @change="selectChanged"
          >
            <el-option
              v-for="item in yzd_nsjsl_dw"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </div>
      <el-form-item label="用途:" prop="yt">
        <el-input v-model="form.yt" placeholder="请输入用途" />
      </el-form-item>
    </el-form>
    <div style="text-align: center">
      <el-button @click="close">取 消</el-button>
      <el-button
        v-preventReClick
        type="primary"
        style="background: #4170ff"
        @click="chemicallShow"
      >确 定</el-button>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="30%"
      :visible.sync="innerVisible"
      append-to-body
      center
      custom-class="neibu"
      :show-close="false"
    >
      <div style="overflow: auto; height: 100%">
        <el-tree
          ref="dataTree"
          :data="HxpTree"
          show-checkbox
          node-key="value"
          :props="defaultProps"
          @check-change="handleCheckChange"
          @node-click="nodeClick"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          @click="innerVisible = false"
        >取 消</el-button>
        <el-button
          v-preventReClick
          type="primary"
          style="background: #4170ff"
          @click="treeQ"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getHxpTree, getkv } from '@/assets/js/common.js'
import { lengthValidate } from '@/assets/js/validate.js'
export default {
  components: {},
  props: {
    content: {
      type: Object
    },
    puptype: {
      type: String
    }
  },
  data() {
    const hxpJiaoyan = (rule, value, callback) => {
      if (!this.form.hxpmc) {
        callback(new Error('请选择化学品!'))
      } else {
        callback()
      }
    }

    return {
      // 控制化学品编辑不可改
      unalterable: false,
      // 单位KV
      yzd_nsjsl_dw: [
        {
          label: '吨',
          value: '1'
        },
        {
          label: '千克',
          value: '2'
        }
      ],
      options: [], // 业务类型
      HxpTree: [], // 化学品树
      // 化学品树数据配置
      defaultProps: {
        children: 'children',
        label: 'label',
        hxpLb: 'hxpLb'
      },
      dialogVisible: true,
      innerVisible: false, // 化学品选择树的开关
      // 数据表单
      form: {
        hxpLbLabel: '',
        id: '',
        yzdHxpId: '',
        nsjsl: '',
        nsjslDw: '',
        nsjslDwLabel: '',
        ywlx: '',
        ywlxLabel: '',
        yt: ''
      },
      rules: {
        ywlx: [
          { required: true, message: '请输入业务类型', trigger: 'change' }
        ],
        hxpmc: [{ required: true, validator: hxpJiaoyan, trigger: 'change' }],
        nsjsl: [
          {
            required: true,
            validator: function(rule, value, callback) {
              if (!value) {
                callback(new Error('请输入'))
              } else if (
                /^[1-9]\d{0,12}(\.\d{1,2})?$|^0(\.\d{1,2})?$/.test(value) ==
                false
              ) {
                callback(new Error('整数位最大长度13位,保留2位小数'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        yt: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 255)
            },
            trigger: 'change'
          }
        ],
        nsjslDwLabel: [
          { required: true, message: '请选择单位', trigger: 'change' }
        ]
      }
    }
  },
  computed: {},
  watch: {},
  beforeDestroy() {},
  created() {
    // 编辑打开时展示行信息
    this.form = this.content
    // 化学品树
    getHxpTree().then((e) => {
      this.HxpTree = e.data.data
    })
    // 业务类型
    getkv('yzd_ywlx').then((e) => {
      this.options = e.data.data
    })
  },
  mounted() {},
  methods: {
    lengthValidate,
    // 年涉及数量单位切换
    selectChanged(val) {
      this.yzd_nsjsl_dw.forEach((element) => {
        if (val == element.value) {
          this.form.nsjslDw = element.value
          this.form.nsjslDwLabel = element.label
        }
      })
    },
    // 业务类型切换
    changenewClass(val) {
      this.options.forEach((element) => {
        if (element.value === val) {
          this.form.ywlxLabel = element.label
        }
      })
    },
    // 添加化学品提交校验
    chemicallShow() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (this.puptype == 'add') {
            this.form.tempAddFlag = '00'
            // 调用父组件保存新增的化学品信息方法
            this.$parent.$parent.closePupop(this.form)
          }
          if (this.puptype == 'edit') {
            // 调用父组件编辑化学品信息方法
            this.$parent.$parent.baosunEditData(this.form)
          }
        } else {
          return false
        }
      })
    },
    close() {
      // 关闭弹窗
      this.$parent.$parent.dialogVisible = false
    },
    // 确定选择的化学品
    treeQ() {
      const node = this.$refs.dataTree.getCheckedNodes()[0]
      if (node) {
        this.form.yzdHxpId = node.value
        this.form.nsjslDw = node.dw
        this.form.hxpmc = node.label
      } else {
        this.form.yzdHxpId = ''
        this.form.nsjslDw = ''
        this.form.hxpLbLabel = ''
      }
      this.innerVisible = false // 关闭化学品树
    },
    handleCheckChange(data, checked, indeterminate) {
      if (checked) {
        this.$refs.dataTree.setCheckedKeys([data.value])
        this.form.hxpLb = data.hxpLb
      }
    },
    nodeClick(data, checked, node) {
      if (data.children == undefined) {
        this.$refs.dataTree.setChecked(data.id, !checked.checked)
      }
    }
  }
}
</script>
<style lang='less' scoped>
/deep/.el-tree .el-tree-node .is-leaf + .el-checkbox .el-checkbox__inner {
  display: inline-block;
}
/deep/.el-tree .el-tree-node .el-checkbox .el-checkbox__inner {
  display: none;
}
.neibu {
  position: relative;
  margin: 0 auto 50px;
  border-radius: 2px;
  box-sizing: border-box;
  width: 50%;
  height: 373px;
  border-radius: 5px;
  .el-dialog__body {
    height: 74%;
    padding: 0;
    width: 85%;
    margin: auto;
  }
}
.chemical_pup_mask {
  .chemical_pup {
    .close {
      width: 15px;
      height: 15px;
      position: absolute;
      right: 30px;
      top: 30px;
      cursor: pointer;
    }
    .preservation {
      margin-top: 64px;
      text-align: center;
      .el-button--primary {
        color: #fff;
        border-color: #4170ff;
        width: 148px;
        height: 60px;
        background-color: #4170ff;
        font-size: 14px;
      }
    }
  }
}
</style>
